// extracted by mini-css-extract-plugin
module.exports = {"container":"_2slGJ-vyOCkfqK9CHGLbkY"};